import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TrainingProgramRecordStatus } from '@app/enums';
import { RecordForm } from '@app/modules/forms/training/components';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnEvent } from '@app/modules/table/interfaces/menu-column-event.interface';
import { TrainingModuleMenuService } from '@app/modules/training/services/training-module-menu.service';
import { AuthService } from '@app/services';
import { TrainingProgramRecord } from '@models/training/training-program-record.model';
import { UpcomingRecordsIndexTable } from '@training/services';
import { CompletedRecordsIndexTable } from '@training/services/tables/completed-records-index/completed-records-index.table';

@Component({
    templateUrl: './records-index.template.html',
    styleUrls: ['./records-index.style.scss'],
})
export class RecordsIndexView {
    table: Table;
    isLoading = false;
    status = null;
    activeRecord?: TrainingProgramRecord;
    isCompleteDialogOpen = false;

    constructor(
        public completed: CompletedRecordsIndexTable,
        public upcoming: UpcomingRecordsIndexTable,
        public auth: AuthService,
        public route: ActivatedRoute,
        protected router: Router,
        protected changeDetector: ChangeDetectorRef,
        public trainingModuleMenuService: TrainingModuleMenuService
    ) {
        const status = this.route.snapshot.url[this.route.snapshot.url.length - 1].path;
        if (status === TrainingProgramRecordStatus.complete) {
            this.table = completed;
        } else {
            this.table = upcoming;
        }
        this.table.onLoading.subscribe((isLoading) => (this.isLoading = isLoading));
        this.table.reload();
    }

    menuAction(event: MenuColumnEvent): void {
        const { data, menuItem } = event;
        this.activeRecord = data as TrainingProgramRecord;
        this.changeDetector.detectChanges();
        if (menuItem.event === 'complete') {
            this.isCompleteDialogOpen = true;
            return;
        }
        this.router.navigate(['/training', 'log', this.activeRecord.id]);
    }

    completeRecord(trainingRecordForm: RecordForm): void {
        trainingRecordForm.submit();
        if (trainingRecordForm.valid) {
            trainingRecordForm.saveRecord();
        }
    }

    afterRecordSave(): void {
        if (this.activeRecord) {
            this.router.navigate(['/training', 'log', this.activeRecord.id]);
        }
    }
}
